import React from "react";
import { shape, func, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import { echeqPropTypes } from "pages/echeck/echeckPropTypes";
import { debinStatusActions, statusTagColor } from "util/debin";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import FormattedAmount from "pages/_components/FormattedAmount";
import useActionByDebinState from "pages/debinPayments/hooks/useActionByIssuedDebinState";
import InfoTag from "pages/echeck/components/InfoTag";
import CustomData from "pages/_components/CustomData/CustomData";

const EmitedebinItem = ({ receibedDebin, setDrawer, isDesktop }) => {
    const debin = {
        ...receibedDebin,
        estado: receibedDebin?.status?.code,
        vendedor: { cuit: receibedDebin?.seller?.documentNumber },
    };
    const { options } = useActionByDebinState(debinStatusActions, debin, setDrawer);
    return (
        <>
            <GridTable.Data alignX={isDesktop ? "center" : "left"}>
                <CustomData
                    titleText="debin.expirery"
                    titleTextType="I18N"
                    valueText={
                        <FormattedDate
                            showTime={false}
                            date={receibedDebin.expirationDate}
                            dateFormat="DD/MM/YYYY HH:mm:ss"
                        />
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 2 : 1}
                rowStart={isDesktop ? 1 : 2}
                alignX={isDesktop ? "center" : "left"}
                alignY="center">
                <CustomData
                    titleText="debin.receiver"
                    titleTextType="I18N"
                    valueText={`${receibedDebin.buyer.titular}
                    ${receibedDebin.buyer.documentType} ${receibedDebin.buyer.documentNumber}`}
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 3 : 1}
                rowStart={isDesktop ? 1 : 3}
                alignX={isDesktop ? "center" : "left"}
                alignY="center">
                <CustomData
                    titleText="debin.amount"
                    titleTextType="I18N"
                    valueText={
                        <FormattedAmount
                            currency={receibedDebin.amount.currency}
                            quantity={receibedDebin.amount.quantity}
                        />
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 4 : 2}
                rowStart={1}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <InfoTag
                    type="info"
                    message={receibedDebin.status.code}
                    tagBackground={statusTagColor(receibedDebin.status.code)}
                    tagClass="tag-word-break"
                />
            </GridTable.Data>
            <GridTable.Data
                columnStart={isDesktop ? 5 : 3}
                rowStart={1}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                {options.length > 0 && (
                    <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
                )}
            </GridTable.Data>
        </>
    );
};

EmitedebinItem.propTypes = {
    receibedDebin: shape(echeqPropTypes).isRequired,
    setDrawer: func.isRequired,
    isDesktop: bool.isRequired,
};

export default EmitedebinItem;
